import * as React from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import {SELECTION_CHANGED, SET_PHOTOS_LOADING} from "../../constants/actions";
import {useStateValue, VehicleStateContext} from "../../reducers/vehicleReducer";
import apiService from "../../services/apiService";
import {useParams} from "react-router";
import {dateToString} from '../../util/core'

export const InspectionSelection = function({inspections, selectedInspectionId}) {
    const params = useParams();
    const {dispatch} = useStateValue(VehicleStateContext);
    
    const handleChange = async function(event) {
        const selectedValue = event.target.value === 0 ? null : event.target.value;
        dispatch({type: SET_PHOTOS_LOADING, payload: {photosLoading: true}});
        const {data} = await apiService.dtoService.getPhotos(params.subdomain, 'Vehicle', params.objectId, params.token, selectedValue);
        dispatch({type: SELECTION_CHANGED, payload: {selectedIndex: event.target.value, photos: data.photos, thumbnails: data.thumbnails}});
    }
    
    return (
        <div style={{marginRight: 24}}>
            <Select
                labelId="inspection-selector-label"
                id="inspection-selector"
                value={selectedInspectionId} 
                variant="standard"
                onChange={handleChange}
                color="success">
                <MenuItem value={0} key={0}>Zusammenfassung</MenuItem>
                {inspections.sort(function (x, y) {return new Date(y.creationDate) - new Date(x.creationDate)}).map(x =>(
                    <MenuItem key={x.id} value={x.id}>{x.inspectionType.name} ({dateToString(new Date(x.creationDate))})</MenuItem>
                ))}
            </Select>
        </div>
    );
}